/**
 * Firebase init for Reputifly Agent dashboard.
 * Config is public-by-design (apiKey is a Firebase project identifier,
 * NOT a secret — auth is enforced server-side via JWT verification + UID allowlist).
 */

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDq6G61NCj2DOVHdCplR_vcWbvLxDgP3P8',
  authDomain: 'reputifly-ai-agent.firebaseapp.com',
  projectId: 'reputifly-ai-agent',
  storageBucket: 'reputifly-ai-agent.firebasestorage.app',
  messagingSenderId: '535461480665',
  appId: '1:535461480665:web:6f6fa96352ebc226e916c8',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)
